// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/classes.css
// module id = 932
// module chunks = 0